import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '@fdm/services';
import { ToastrService } from 'ngx-toastr';

export const policyGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const toastr = inject(ToastrService);
  const roles = auth.getRoles();

  if (!roles.length) {
    toastr.error("You don't have permission to access this page.");
    router.navigate(['/reports']);
  }

  return roles.length > 0;
};
